import React from 'react'

export default function footer() {
  return (
    <div className='bg-dark text-light text-center py-3'>
      Copyright &copy; MytodoList.com</div>
  )
}

